// js
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import KeyGoalItem from './KeyGoalItem';


const KeyGoalsArea = ({ title, goals, active, spacing }) => {
  const classNames = classnames({
    'analytics__key-goals-area-pptx': true,
    'analytics__key-goals-spacing-100': spacing === 1,
    'analytics__key-goals-spacing-50': spacing === 2,
    'analytics__key-goals-spacing-33': spacing === 3
  });

  return (
    <div className={classNames}>
      <h3>{title}</h3>
      {goals.map(goal =>
        (<KeyGoalItem
          active={active}
          key={goal.id}
          goal={goal}
        />)
      )}
    </div>
  );
};

KeyGoalsArea.propTypes = {
  title: PropTypes.string.isRequired,
  goals: PropTypes.array.isRequired,
  active: PropTypes.bool,
  spacing: PropTypes.number.isRequired
};

export default KeyGoalsArea;



// WEBPACK FOOTER //
// ./src/components/analytics/pptx/KeyGoalsArea.js